module.exports = __webpack_public_path__ + "static/img/09.f5f02b0c.png";